/**
 * Deterministic color assignment for locations.
 * Generates consistent colors from location_code using a curated palette.
 */

const PALETTE = [
  '#3B82F6', // blue-500
  '#10B981', // emerald-500
  '#F59E0B', // amber-500
  '#EF4444', // red-500
  '#2a5ec2', // brand-blue-light
  '#14B8A6', // teal-500
  '#EC4899', // pink-500
  '#F97316', // orange-500
  '#06B6D4', // cyan-500
  '#84CC16', // lime-500
  '#E11D48', // rose-600
  '#1b449d', // brand-blue
]

function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash |= 0 // Convert to 32-bit int
  }
  return Math.abs(hash)
}

/**
 * Get a deterministic color for a location based on its code.
 * Same code always returns the same color.
 */
export function getLocationColor(locationCode: string): string {
  const idx = hashCode(locationCode.toUpperCase()) % PALETTE.length
  return PALETTE[idx]
}

/** Network/org-wide accent color (brand blue) */
export const NETWORK_COLOR = '#1b449d'
